/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const dashboardData = {
  fegli: {
    17: [0.43, 0.043, 0.43, 0.347],
    18: [0.43, 0.043, 0.43, 0.347],
    19: [0.43, 0.043, 0.43, 0.347],
    20: [0.43, 0.043, 0.43, 0.347],
    21: [0.43, 0.043, 0.43, 0.347],
    22: [0.43, 0.043, 0.43, 0.347],
    23: [0.43, 0.043, 0.43, 0.347],
    24: [0.43, 0.043, 0.43, 0.347],
    25: [0.43, 0.043, 0.43, 0.347],
    26: [0.43, 0.043, 0.43, 0.347],
    27: [0.43, 0.043, 0.43, 0.347],
    28: [0.43, 0.043, 0.43, 0.347],
    29: [0.43, 0.043, 0.43, 0.347],
    30: [0.43, 0.043, 0.43, 0.347],
    31: [0.43, 0.043, 0.43, 0.347],
    32: [0.43, 0.043, 0.43, 0.347],
    33: [0.43, 0.043, 0.43, 0.347],
    34: [0.43, 0.043, 0.43, 0.347],
    35: [0.43, 0.043, 0.52, 0.347],
    36: [0.43, 0.043, 0.52, 0.347],
    37: [0.43, 0.043, 0.52, 0.347],
    38: [0.43, 0.043, 0.52, 0.347],
    39: [0.43, 0.043, 0.52, 0.347],
    40: [0.65, 0.065, 0.8, 0.347],
    41: [0.65, 0.065, 0.8, 0.347],
    42: [0.65, 0.065, 0.8, 0.347],
    43: [0.65, 0.065, 0.8, 0.347],
    44: [0.65, 0.065, 0.8, 0.347],
    45: [1.3, 0.13, 1.15, 0.347],
    46: [1.3, 0.13, 1.15, 0.347],
    47: [1.3, 0.13, 1.15, 0.347],
    48: [1.3, 0.13, 1.15, 0.347],
    49: [1.3, 0.13, 1.15, 0.347],
    50: [2.17, 0.217, 1.8, 0.347],
    51: [2.17, 0.217, 1.8, 0.347],
    52: [2.17, 0.217, 1.8, 0.347],
    53: [2.17, 0.217, 1.8, 0.347],
    54: [2.17, 0.217, 1.8, 0.347],
    55: [3.9, 0.39, 2.88, 0.347],
    56: [3.9, 0.39, 2.88, 0.347],
    57: [3.9, 0.39, 2.88, 0.347],
    58: [3.9, 0.39, 2.88, 0.347],
    59: [3.9, 0.39, 2.88, 0.347],
    60: [13, 0.867, 5.27, 0.347],
    61: [13, 0.867, 5.27, 0.347],
    62: [13, 0.867, 5.27, 0.347],
    63: [13, 0.867, 5.27, 0.347],
    64: [13, 0.867, 5.27, 0.347],
    65: [0, 1.04, 6.13, 0.347],
    66: [0, 1.04, 6.13, 0.347],
    67: [0, 1.04, 6.13, 0.347],
    68: [0, 1.04, 6.13, 0.347],
    69: [0, 1.04, 6.13, 0.347],
    70: [0, 1.863, 8.3, 0.347],
    71: [0, 1.863, 8.3, 0.347],
    72: [0, 1.863, 8.3, 0.347],
    73: [0, 1.863, 8.3, 0.347],
    74: [0, 1.863, 8.3, 0.347],
    75: [0, 3.9, 12.48, 0.347],
    76: [0, 3.9, 12.48, 0.347],
    77: [0, 3.9, 12.48, 0.347],
    78: [0, 3.9, 12.48, 0.347],
    79: [0, 3.9, 12.48, 0.347],
    80: [0, 6.24, 16.9, 0.347],
    81: [0, 6.24, 16.9, 0.347],
    82: [0, 6.24, 16.9, 0.347],
    83: [0, 6.24, 16.9, 0.347],
    84: [0, 6.24, 16.9, 0.347],
    85: [0, 6.24, 16.9, 0.347],
    86: [0, 6.24, 16.9, 0.347],
    87: [0, 6.24, 16.9, 0.347],
    88: [0, 6.24, 16.9, 0.347],
    89: [0, 6.24, 16.9, 0.347],
    90: [0, 6.24, 16.9, 0.347],
    91: [0, 6.24, 16.9, 0.347],
    92: [0, 6.24, 16.9, 0.347],
    93: [0, 6.24, 16.9, 0.347],
    94: [0, 6.24, 16.9, 0.347],
    95: [0, 6.24, 16.9, 0.347],
    96: [0, 6.24, 16.9, 0.347],
    97: [0, 6.24, 16.9, 0.347],
    98: [0, 6.24, 16.9, 0.347],
    99: [0, 6.24, 16.9, 0.347],
    100: [0, 6.24, 16.9, 0.347],
    101: [0, 6.24, 16.9, 0.347],
    102: [0, 6.24, 16.9, 0.347],
    103: [0, 6.24, 16.9, 0.347],
  },
  socialsecurityage: {
    1930: 65,
    1931: 65,
    1932: 65,
    1933: 65,
    1934: 65,
    1935: 65,
    1936: 65,
    1937: 65,
    1938: 65.2,
    1939: 65.3,
    1940: 65.5,
    1941: 65.7,
    1942: 65.8,
    1943: 66,
    1944: 66,
    1945: 66,
    1946: 66,
    1947: 66,
    1948: 66,
    1949: 66,
    1950: 66,
    1951: 66,
    1952: 66,
    1953: 66,
    1954: 66,
    1955: 66.2,
    1956: 66.3,
    1957: 66.5,
    1958: 66.7,
    1959: 66.8,
    1960: 67,
    1961: 67,
    1962: 67,
    1963: 67,
    1964: 67,
    1965: 67,
    1966: 67,
    1967: 67,
    1968: 67,
    1969: 67,
    1970: 67,
    1971: 67,
    1972: 67,
    1973: 67,
    1974: 67,
    1975: 67,
    1976: 67,
    1977: 67,
    1978: 67,
    1979: 67,
    1980: 67,
    1981: 67,
    1982: 67,
    1983: 67,
    1984: 67,
    1985: 67,
    1986: 67,
    1987: 67,
    1988: 67,
    1989: 67,
    1990: 67,
    1991: 67,
    1992: 67,
    1993: 67,
    1994: 67,
    1995: 67,
    1996: 67,
    1997: 67,
    1998: 67,
    1999: 67,
    2000: 67,
    2001: 67,
    2002: 67,
    2003: 67,
    2004: 67,
    2005: 67,
    2006: 67,
    2007: 67,
    2008: 67,
    2009: 67,
    2010: 67,
    2011: 67,
    2012: 67,
    2013: 67,
    2014: 67,
    2015: 67,
    2016: 67,
    2017: 67,
    2018: 67,
  },
  socialsecuritytaxes: {
    1937: [3000, 0.062],
    1938: [3000, 0.062],
    1939: [3000, 0.062],
    1940: [3000, 0.062],
    1941: [3000, 0.062],
    1942: [3000, 0.062],
    1943: [3000, 0.062],
    1944: [3000, 0.062],
    1945: [3000, 0.062],
    1946: [3000, 0.062],
    1947: [3000, 0.062],
    1948: [3000, 0.062],
    1949: [3000, 0.062],
    1950: [3000, 0.062],
    1951: [3600, 0.062],
    1952: [3600, 0.062],
    1953: [3600, 0.062],
    1954: [3600, 0.062],
    1955: [4200, 0.062],
    1956: [4200, 0.062],
    1957: [4200, 0.062],
    1958: [4200, 0.062],
    1959: [4800, 0.062],
    1960: [4800, 0.062],
    1961: [4800, 0.062],
    1962: [4800, 0.062],
    1963: [4800, 0.062],
    1964: [4800, 0.062],
    1965: [4800, 0.062],
    1966: [6600, 0.062],
    1967: [6600, 0.062],
    1968: [7800, 0.062],
    1969: [7800, 0.062],
    1970: [7800, 0.062],
    1971: [7800, 0.062],
    1972: [9000, 0.062],
    1973: [10800, 0.062],
    1974: [13200, 0.062],
    1975: [14100, 0.062],
    1976: [15300, 0.062],
    1977: [16500, 0.062],
    1978: [17700, 0.062],
    1979: [22900, 0.062],
    1980: [25900, 0.062],
    1981: [29700, 0.062],
    1982: [32400, 0.062],
    1983: [35700, 0.062],
    1984: [37800, 0.062],
    1985: [39600, 0.062],
    1986: [42000, 0.062],
    1987: [43800, 0.062],
    1988: [45000, 0.062],
    1989: [48000, 0.062],
    1990: [51300, 0.062],
    1991: [53400, 0.062],
    1992: [55500, 0.062],
    1993: [57600, 0.062],
    1994: [60600, 0.062],
    1995: [61200, 0.062],
    1996: [62700, 0.062],
    1997: [65400, 0.062],
    1998: [68400, 0.062],
    1999: [72600, 0.062],
    2000: [76200, 0.062],
    2001: [80400, 0.062],
    2002: [84900, 0.062],
    2003: [87000, 0.062],
    2004: [87900, 0.062],
    2005: [90000, 0.062],
    2006: [94200, 0.062],
    2007: [97500, 0.062],
    2008: [102000, 0.062],
    2009: [106800, 0.062],
    2010: [106800, 0.062],
    2011: [106800, 0.062],
    2012: [110100, 0.062],
    2013: [113700, 0.062],
    2014: [117000, 0.062],
    2015: [118500, 0.062],
    2016: [118500, 0.062],
    2017: [127200, 0.062],
    2018: [128400, 0.062],
    2019: [132900, 0.062],
    2020: [137700, 0.062],
    2021: [142800, 0.062],
    2022: [147000, 0.062],
    2023: [160200, 0.062],
  },
  payoutratio: {
    20: {
      0: { male: 0.0585, female: 0.0582 },
      1: { male: 0.0427, female: 0.0422 },
      2: { male: 0.0408, female: 0.0404 },
      3: { male: 0.0329, female: 0.0324 },
      4: { male: 0.0257, female: 0.0252 },
      5: { male: 0.0156, female: 0.0151 },
    },
    21: {
      0: { male: 0.0587, female: 0.0583 },
      1: { male: 0.0428, female: 0.0423 },
      2: { male: 0.041, female: 0.0406 },
      3: { male: 0.033, female: 0.0326 },
      4: { male: 0.0259, female: 0.0253 },
      5: { male: 0.0158, female: 0.0154 },
    },
    22: {
      0: { male: 0.0588, female: 0.0584 },
      1: { male: 0.043, female: 0.0425 },
      2: { male: 0.0412, female: 0.0407 },
      3: { male: 0.0332, female: 0.0327 },
      4: { male: 0.0261, female: 0.0256 },
      5: { male: 0.0161, female: 0.0156 },
    },
    23: {
      0: { male: 0.0589, female: 0.0585 },
      1: { male: 0.0431, female: 0.0426 },
      2: { male: 0.0413, female: 0.0409 },
      3: { male: 0.0334, female: 0.0329 },
      4: { male: 0.0263, female: 0.0258 },
      5: { male: 0.0163, female: 0.0158 },
    },
    24: {
      0: { male: 0.059, female: 0.0586 },
      1: { male: 0.0433, female: 0.0428 },
      2: { male: 0.0415, female: 0.041 },
      3: { male: 0.0336, female: 0.0331 },
      4: { male: 0.0265, female: 0.026 },
      5: { male: 0.0166, female: 0.0161 },
    },
    25: {
      0: { male: 0.0591, female: 0.0587 },
      1: { male: 0.0435, female: 0.0429 },
      2: { male: 0.0417, female: 0.0412 },
      3: { male: 0.0339, female: 0.0333 },
      4: { male: 0.0268, female: 0.0262 },
      5: { male: 0.0169, female: 0.0163 },
    },
    26: {
      0: { male: 0.0593, female: 0.0588 },
      1: { male: 0.0437, female: 0.0431 },
      2: { male: 0.0419, female: 0.0414 },
      3: { male: 0.0341, female: 0.0335 },
      4: { male: 0.027, female: 0.0264 },
      5: { male: 0.0171, female: 0.0166 },
    },
    27: {
      0: { male: 0.0594, female: 0.059 },
      1: { male: 0.0439, female: 0.0433 },
      2: { male: 0.0421, female: 0.0416 },
      3: { male: 0.0343, female: 0.0337 },
      4: { male: 0.0273, female: 0.0267 },
      5: { male: 0.0174, female: 0.0169 },
    },
    28: {
      0: { male: 0.0596, female: 0.0591 },
      1: { male: 0.0441, female: 0.0435 },
      2: { male: 0.0423, female: 0.0418 },
      3: { male: 0.0346, female: 0.034 },
      4: { male: 0.0275, female: 0.0269 },
      5: { male: 0.0177, female: 0.0171 },
    },
    29: {
      0: { male: 0.0597, female: 0.0592 },
      1: { male: 0.0443, female: 0.0437 },
      2: { male: 0.0426, female: 0.042 },
      3: { male: 0.0348, female: 0.0342 },
      4: { male: 0.0278, female: 0.0272 },
      5: { male: 0.018, female: 0.0174 },
    },
    30: {
      0: { male: 0.0599, female: 0.0594 },
      1: { male: 0.0445, female: 0.0439 },
      2: { male: 0.0428, female: 0.0422 },
      3: { male: 0.0351, female: 0.0345 },
      4: { male: 0.0115, female: 0.0108 },
      5: { male: 0.0082, female: 0.0076 },
    },
    31: {
      0: { male: 0.0601, female: 0.0596 },
      1: { male: 0.0448, female: 0.0441 },
      2: { male: 0.043, female: 0.0424 },
      3: { male: 0.0354, female: 0.0347 },
      4: { male: 0.0117, female: 0.0111 },
      5: { male: 0.0084, female: 0.0078 },
    },
    32: {
      0: { male: 0.0602, female: 0.0597 },
      1: { male: 0.045, female: 0.0444 },
      2: { male: 0.0433, female: 0.0427 },
      3: { male: 0.0357, female: 0.035 },
      4: { male: 0.0287, female: 0.0115 },
      5: { male: 0.0087, female: 0.0082 },
    },
    33: {
      0: { male: 0.0605, female: 0.0599 },
      1: { male: 0.0453, female: 0.0446 },
      2: { male: 0.0436, female: 0.0429 },
      3: { male: 0.0359, female: 0.0353 },
      4: { male: 0.029, female: 0.0117 },
      5: { male: 0.0089, female: 0.0084 },
    },
    34: {
      0: { male: 0.0607, female: 0.0601 },
      1: { male: 0.0456, female: 0.0449 },
      2: { male: 0.0438, female: 0.0432 },
      3: { male: 0.0363, female: 0.0355 },
      4: { male: 0.0294, female: 0.0286 },
      5: { male: 0.0093, female: 0.0087 },
    },
    35: {
      0: { male: 0.0609, female: 0.0603 },
      1: { male: 0.0459, female: 0.0451 },
      2: { male: 0.0441, female: 0.0434 },
      3: { male: 0.0366, female: 0.0358 },
      4: { male: 0.0297, female: 0.029 },
      5: { male: 0.0096, female: 0.0089 },
    },
    36: {
      0: { male: 0.0611, female: 0.0605 },
      1: { male: 0.0462, female: 0.0454 },
      2: { male: 0.0444, female: 0.0437 },
      3: { male: 0.0369, female: 0.0362 },
      4: { male: 0.0301, female: 0.0293 },
      5: { male: 0.0099, female: 0.0093 },
    },
    37: {
      0: { male: 0.0614, female: 0.0608 },
      1: { male: 0.0465, female: 0.0457 },
      2: { male: 0.0448, female: 0.044 },
      3: { male: 0.0373, female: 0.0365 },
      4: { male: 0.0305, female: 0.0296 },
      5: { male: 0.0102, female: 0.0096 },
    },
    38: {
      0: { male: 0.0617, female: 0.061 },
      1: { male: 0.0469, female: 0.046 },
      2: { male: 0.0451, female: 0.0443 },
      3: { male: 0.0377, female: 0.0368 },
      4: { male: 0.0309, female: 0.03 },
      5: { male: 0.0106, female: 0.0099 },
    },
    39: {
      0: { male: 0.062, female: 0.0613 },
      1: { male: 0.0473, female: 0.0464 },
      2: { male: 0.0455, female: 0.0447 },
      3: { male: 0.0381, female: 0.0372 },
      4: { male: 0.0313, female: 0.0304 },
      5: { male: 0.011, female: 0.0102 },
    },
    40: {
      0: { male: 0.0623, female: 0.0615 },
      1: { male: 0.0477, female: 0.0467 },
      2: { male: 0.0459, female: 0.045 },
      3: { male: 0.0385, female: 0.0376 },
      4: { male: 0.0317, female: 0.0308 },
      5: { male: 0.0115, female: 0.0106 },
    },
    41: {
      0: { male: 0.0626, female: 0.0618 },
      1: { male: 0.0481, female: 0.0471 },
      2: { male: 0.0463, female: 0.0454 },
      3: { male: 0.0389, female: 0.038 },
      4: { male: 0.0322, female: 0.0312 },
      5: { male: 0.0118, female: 0.011 },
    },
    42: {
      0: { male: 0.063, female: 0.0622 },
      1: { male: 0.0485, female: 0.0475 },
      2: { male: 0.0467, female: 0.0457 },
      3: { male: 0.0393, female: 0.0384 },
      4: { male: 0.0326, female: 0.0316 },
      5: { male: 0.0235, female: 0.0113 },
    },
    43: {
      0: { male: 0.0633, female: 0.0625 },
      1: { male: 0.049, female: 0.0479 },
      2: { male: 0.0471, female: 0.0461 },
      3: { male: 0.0398, female: 0.0388 },
      4: { male: 0.0331, female: 0.0321 },
      5: { male: 0.0242, female: 0.0118 },
    },
    44: {
      0: { male: 0.0637, female: 0.0628 },
      1: { male: 0.0495, female: 0.0484 },
      2: { male: 0.0476, female: 0.0466 },
      3: { male: 0.0403, female: 0.0392 },
      4: { male: 0.0336, female: 0.0325 },
      5: { male: 0.0249, female: 0.0235 },
    },
    45: {
      0: { male: 0.0641, female: 0.0632 },
      1: { male: 0.05, female: 0.0488 },
      2: { male: 0.0481, female: 0.047 },
      3: { male: 0.0408, female: 0.0397 },
      4: { male: 0.0342, female: 0.033 },
      5: { male: 0.0256, female: 0.0241 },
    },
    46: {
      0: { male: 0.0645, female: 0.0635 },
      1: { male: 0.0506, female: 0.0493 },
      2: { male: 0.0485, female: 0.0474 },
      3: { male: 0.0413, female: 0.0402 },
      4: { male: 0.0347, female: 0.0335 },
      5: { male: 0.0263, female: 0.0248 },
    },
    47: {
      0: { male: 0.065, female: 0.0639 },
      1: { male: 0.0511, female: 0.0498 },
      2: { male: 0.0491, female: 0.0479 },
      3: { male: 0.0419, female: 0.0407 },
      4: { male: 0.0353, female: 0.034 },
      5: { male: 0.027, female: 0.0254 },
    },
    48: {
      0: { male: 0.0654, female: 0.0644 },
      1: { male: 0.0517, female: 0.0504 },
      2: { male: 0.0496, female: 0.0484 },
      3: { male: 0.0425, female: 0.0412 },
      4: { male: 0.0359, female: 0.0346 },
      5: { male: 0.0278, female: 0.0262 },
    },
    49: {
      0: { male: 0.0659, female: 0.0648 },
      1: { male: 0.0525, female: 0.051 },
      2: { male: 0.0502, female: 0.0489 },
      3: { male: 0.0431, female: 0.0418 },
      4: { male: 0.0365, female: 0.0352 },
      5: { male: 0.0286, female: 0.0269 },
    },
    50: {
      0: { male: 0.0664, female: 0.0653 },
      1: { male: 0.0532, female: 0.0516 },
      2: { male: 0.0508, female: 0.0495 },
      3: { male: 0.0437, female: 0.0424 },
      4: { male: 0.0372, female: 0.0358 },
      5: { male: 0.0295, female: 0.0277 },
    },
    51: {
      0: { male: 0.067, female: 0.0658 },
      1: { male: 0.0541, female: 0.0521 },
      2: { male: 0.0514, female: 0.0501 },
      3: { male: 0.0444, female: 0.043 },
      4: { male: 0.0379, female: 0.0364 },
      5: { male: 0.0303, female: 0.0285 },
    },
    52: {
      0: { male: 0.0676, female: 0.0664 },
      1: { male: 0.0549, female: 0.0528 },
      2: { male: 0.0521, female: 0.0507 },
      3: { male: 0.0451, female: 0.0436 },
      4: { male: 0.0386, female: 0.0371 },
      5: { male: 0.0313, female: 0.0293 },
    },
    53: {
      0: { male: 0.0683, female: 0.067 },
      1: { male: 0.0558, female: 0.0536 },
      2: { male: 0.0528, female: 0.0514 },
      3: { male: 0.0458, female: 0.0443 },
      4: { male: 0.0393, female: 0.0378 },
      5: { male: 0.0322, female: 0.0302 },
    },
    54: {
      0: { male: 0.0689, female: 0.0676 },
      1: { male: 0.0567, female: 0.0544 },
      2: { male: 0.0536, female: 0.0521 },
      3: { male: 0.0466, female: 0.0451 },
      4: { male: 0.0402, female: 0.0386 },
      5: { male: 0.0332, female: 0.0311 },
    },
    55: {
      0: { male: 0.0697, female: 0.0683 },
      1: { male: 0.0576, female: 0.0553 },
      2: { male: 0.0544, female: 0.0529 },
      3: { male: 0.0475, female: 0.0459 },
      4: { male: 0.041, female: 0.0394 },
      5: { male: 0.0342, female: 0.0321 },
    },
    56: {
      0: { male: 0.0705, female: 0.069 },
      1: { male: 0.0588, female: 0.0565 },
      2: { male: 0.0553, female: 0.0536 },
      3: { male: 0.0484, female: 0.0467 },
      4: { male: 0.0419, female: 0.0402 },
      5: { male: 0.0354, female: 0.0332 },
    },
    57: {
      0: { male: 0.0713, female: 0.0697 },
      1: { male: 0.06, female: 0.0577 },
      2: { male: 0.0562, female: 0.0545 },
      3: { male: 0.0493, female: 0.0475 },
      4: { male: 0.0429, female: 0.0411 },
      5: { male: 0.0366, female: 0.0344 },
    },
    58: {
      0: { male: 0.0722, female: 0.0705 },
      1: { male: 0.0612, female: 0.059 },
      2: { male: 0.0572, female: 0.0553 },
      3: { male: 0.0504, female: 0.0484 },
      4: { male: 0.044, female: 0.042 },
      5: { male: 0.0379, female: 0.0357 },
    },
    59: {
      0: { male: 0.0732, female: 0.0713 },
      1: { male: 0.0625, female: 0.0604 },
      2: { male: 0.0582, female: 0.0562 },
      3: { male: 0.0514, female: 0.0494 },
      4: { male: 0.045, female: 0.0429 },
      5: { male: 0.0393, female: 0.0371 },
    },
    60: {
      0: { male: 0.0741, female: 0.0722 },
      1: { male: 0.0639, female: 0.0618 },
      2: { male: 0.0593, female: 0.0572 },
      3: { male: 0.0525, female: 0.0504 },
      4: { male: 0.0462, female: 0.0439 },
      5: { male: 0.0407, female: 0.0385 },
    },
    61: {
      0: { male: 0.0752, female: 0.0731 },
      1: { male: 0.0649, female: 0.0628 },
      2: { male: 0.0605, female: 0.0582 },
      3: { male: 0.0537, female: 0.0514 },
      4: { male: 0.0474, female: 0.045 },
      5: { male: 0.042, female: 0.0397 },
    },
    62: {
      0: { male: 0.0762, female: 0.0741 },
      1: { male: 0.0661, female: 0.0638 },
      2: { male: 0.0617, female: 0.0592 },
      3: { male: 0.055, female: 0.0524 },
      4: { male: 0.0487, female: 0.0461 },
      5: { male: 0.0433, female: 0.0409 },
    },
    63: {
      0: { male: 0.0773, female: 0.075 },
      1: { male: 0.0675, female: 0.065 },
      2: { male: 0.0631, female: 0.0603 },
      3: { male: 0.0564, female: 0.0535 },
      4: { male: 0.0501, female: 0.0475 },
      5: { male: 0.0449, female: 0.0422 },
    },
    64: {
      0: { male: 0.0784, female: 0.0758 },
      1: { male: 0.069, female: 0.0663 },
      2: { male: 0.0644, female: 0.0614 },
      3: { male: 0.0577, female: 0.0547 },
      4: { male: 0.0518, female: 0.0489 },
      5: { male: 0.0466, female: 0.0437 },
    },
    65: {
      0: { male: 0.0798, female: 0.0767 },
      1: { male: 0.0696, female: 0.0667 },
      2: { male: 0.0658, female: 0.0626 },
      3: { male: 0.0592, female: 0.0559 },
      4: { male: 0.053, female: 0.0496 },
      5: { male: 0.047, female: 0.044 },
    },
    66: {
      0: { male: 0.0814, female: 0.0778 },
      1: { male: 0.0711, female: 0.068 },
      2: { male: 0.0673, female: 0.0638 },
      3: { male: 0.0608, female: 0.0571 },
      4: { male: 0.0546, female: 0.0509 },
      5: { male: 0.0487, female: 0.0455 },
    },
    67: {
      0: { male: 0.0829, female: 0.079 },
      1: { male: 0.0727, female: 0.0694 },
      2: { male: 0.0688, female: 0.0651 },
      3: { male: 0.0624, female: 0.0585 },
      4: { male: 0.0562, female: 0.0523 },
      5: { male: 0.0505, female: 0.0471 },
    },
    68: {
      0: { male: 0.0846, female: 0.0804 },
      1: { male: 0.0744, female: 0.071 },
      2: { male: 0.0705, female: 0.0664 },
      3: { male: 0.0641, female: 0.0599 },
      4: { male: 0.058, female: 0.054 },
      5: { male: 0.0524, female: 0.0489 },
    },
    69: {
      0: { male: 0.0864, female: 0.082 },
      1: { male: 0.0763, female: 0.0727 },
      2: { male: 0.072, female: 0.0677 },
      3: { male: 0.0659, female: 0.0614 },
      4: { male: 0.0598, female: 0.0558 },
      5: { male: 0.0544, female: 0.0507 },
    },
    70: {
      0: { male: 0.0883, female: 0.0837 },
      1: { male: 0.0782, female: 0.0745 },
      2: { male: 0.0735, female: 0.0692 },
      3: { male: 0.0675, female: 0.0631 },
      4: { male: 0.0617, female: 0.0578 },
      5: { male: 0.0566, female: 0.0527 },
    },
    71: {
      0: { male: 0.0904, female: 0.0853 },
      1: { male: 0.0806, female: 0.0767 },
      2: { male: 0.0752, female: 0.071 },
      3: { male: 0.0694, female: 0.0654 },
      4: { male: 0.0641, female: 0.0601 },
      5: { male: 0.0591, female: 0.055 },
    },
    72: {
      0: { male: 0.0924, female: 0.0873 },
      1: { male: 0.0831, female: 0.0791 },
      2: { male: 0.0775, female: 0.0734 },
      3: { male: 0.072, female: 0.0679 },
      4: { male: 0.0668, female: 0.0626 },
      5: { male: 0.0617, female: 0.0575 },
    },
    73: {
      0: { male: 0.0946, female: 0.0892 },
      1: { male: 0.0857, female: 0.0816 },
      2: { male: 0.0801, female: 0.0759 },
      3: { male: 0.0747, female: 0.0705 },
      4: { male: 0.0695, female: 0.0652 },
      5: { male: 0.0645, female: 0.0601 },
    },
    74: {
      0: { male: 0.0969, female: 0.0912 },
      1: { male: 0.0883, female: 0.0842 },
      2: { male: 0.0828, female: 0.0786 },
      3: { male: 0.0775, female: 0.0732 },
      4: { male: 0.0723, female: 0.0679 },
      5: { male: 0.0673, female: 0.0629 },
    },
    75: {
      0: { male: 0.0992, female: 0.0933 },
      1: { male: 0.089, female: 0.0846 },
      2: { male: 0.0835, female: 0.0789 },
      3: { male: 0.078, female: 0.0735 },
      4: { male: 0.0728, female: 0.0682 },
      5: { male: 0.0678, female: 0.0631 },
    },
    76: {
      0: { male: 0.1015, female: 0.0955 },
      1: { male: 0.0914, female: 0.087 },
      2: { male: 0.0858, female: 0.0814 },
      3: { male: 0.0805, female: 0.0759 },
      4: { male: 0.0754, female: 0.0707 },
      5: { male: 0.0704, female: 0.0657 },
    },
    77: {
      0: { male: 0.1038, female: 0.0977 },
      1: { male: 0.0937, female: 0.0894 },
      2: { male: 0.0883, female: 0.0838 },
      3: { male: 0.0831, female: 0.0785 },
      4: { male: 0.0779, female: 0.0733 },
      5: { male: 0.073, female: 0.0684 },
    },
    78: {
      0: { male: 0.106, female: 0.0998 },
      1: { male: 0.0961, female: 0.0918 },
      2: { male: 0.0911, female: 0.0864 },
      3: { male: 0.0856, female: 0.0811 },
      4: { male: 0.0806, female: 0.076 },
      5: { male: 0.0758, female: 0.0711 },
    },
    79: {
      0: { male: 0.1083, female: 0.1021 },
      1: { male: 0.0984, female: 0.0943 },
      2: { male: 0.0936, female: 0.089 },
      3: { male: 0.0881, female: 0.0837 },
      4: { male: 0.0832, female: 0.0787 },
      5: { male: 0.0784, female: 0.0738 },
    },
    80: {
      0: { male: 0.1105, female: 0.1043 },
      1: { male: 0.1008, female: 0.0968 },
      2: { male: 0.0964, female: 0.0915 },
      3: { male: 0.0908, female: 0.0864 },
      4: { male: 0.0858, female: 0.0814 },
      5: { male: 0.081, female: 0.0765 },
    },
  },
  pricetables: {
    20: {
      0: { male: 18.71, female: 18.84 },
      1: { male: 26.26, female: 26.6 },
      2: { male: 28.93, female: 29.32 },
      3: { male: 36.88, female: 37.55 },
      4: { male: 48.57, female: 49.78 },
      5: { male: 77.93, female: 87.44 },
    },
    21: {
      0: { male: 18.67, female: 18.81 },
      1: { male: 26.15, female: 26.49 },
      2: { male: 28.78, female: 29.18 },
      3: { male: 36.6, female: 37.28 },
      4: { male: 48.04, female: 49.27 },
      5: { male: 76.54, female: 85.84 },
    },
    22: {
      0: { male: 18.64, female: 18.78 },
      1: { male: 26.03, female: 26.38 },
      2: { male: 28.63, female: 29.03 },
      3: { male: 36.31, female: 37.01 },
      4: { male: 47.52, female: 48.75 },
      5: { male: 75.12, female: 84.26 },
    },
    23: {
      0: { male: 18.6, female: 18.74 },
      1: { male: 25.91, female: 26.27 },
      2: { male: 28.47, female: 28.88 },
      3: { male: 36.02, female: 36.73 },
      4: { male: 46.99, female: 48.23 },
      5: { male: 73.48, female: 76.39 },
    },
    24: {
      0: { male: 18.56, female: 18.71 },
      1: { male: 25.78, female: 26.15 },
      2: { male: 28.3, female: 28.72 },
      3: { male: 35.73, female: 36.44 },
      4: { male: 46.46, female: 47.7 },
      5: { male: 71.87, female: 74.94 },
    },
    25: {
      0: { male: 18.52, female: 18.67 },
      1: { male: 25.65, female: 26.02 },
      2: { male: 28.14, female: 28.56 },
      3: { male: 35.43, female: 36.15 },
      4: { male: 45.92, female: 47.16 },
      5: { male: 70.28, female: 73.33 },
    },
    26: {
      0: { male: 18.47, female: 18.63 },
      1: { male: 25.52, female: 25.9 },
      2: { male: 27.97, female: 28.4 },
      3: { male: 35.13, female: 35.85 },
      4: { male: 45.38, female: 46.63 },
      5: { male: 68.72, female: 71.74 },
    },
    27: {
      0: { male: 18.43, female: 18.59 },
      1: { male: 25.38, female: 25.76 },
      2: { male: 27.79, female: 28.23 },
      3: { male: 34.82, female: 35.55 },
      4: { male: 44.84, female: 46.08 },
      5: { male: 67.19, female: 70.17 },
    },
    28: {
      0: { male: 18.38, female: 18.54 },
      1: { male: 25.23, female: 25.62 },
      2: { male: 27.61, female: 28.05 },
      3: { male: 34.51, female: 35.24 },
      4: { male: 44.29, female: 45.53 },
      5: { male: 65.68, female: 68.63 },
    },
    29: {
      0: { male: 18.33, female: 18.49 },
      1: { male: 25.09, female: 25.48 },
      2: { male: 27.43, female: 27.87 },
      3: { male: 34.19, female: 34.93 },
      4: { male: 43.74, female: 44.98 },
      5: { male: 64.19, female: 67.11 },
    },
    30: {
      0: { male: 18.28, female: 18.44 },
      1: { male: 24.93, female: 25.33 },
      2: { male: 27.23, female: 27.68 },
      3: { male: 33.86, female: 34.6 },
      4: { male: 43.18, female: 44.42 },
      5: { male: 62.72, female: 65.62 },
    },
    31: {
      0: { male: 18.22, female: 18.39 },
      1: { male: 24.77, female: 25.18 },
      2: { male: 27.04, female: 27.49 },
      3: { male: 33.53, female: 34.28 },
      4: { male: 42.61, female: 43.85 },
      5: { male: 61.28, female: 64.15 },
    },
    32: {
      0: { male: 18.16, female: 18.33 },
      1: { male: 24.6, female: 25.02 },
      2: { male: 26.83, female: 27.29 },
      3: { male: 33.19, female: 33.94 },
      4: { male: 42.03, female: 43.28 },
      5: { male: 59.86, female: 62.7 },
    },
    33: {
      0: { male: 18.1, female: 18.27 },
      1: { male: 24.43, female: 24.86 },
      2: { male: 26.62, female: 27.09 },
      3: { male: 32.84, female: 33.61 },
      4: { male: 41.45, female: 42.71 },
      5: { male: 58.45, female: 61.27 },
    },
    34: {
      0: { male: 18.03, female: 18.21 },
      1: { male: 24.25, female: 24.68 },
      2: { male: 26.4, female: 26.89 },
      3: { male: 32.49, female: 33.26 },
      4: { male: 40.87, female: 42.13 },
      5: { male: 57.07, female: 59.86 },
    },
    35: {
      0: { male: 17.96, female: 18.15 },
      1: { male: 24.04, female: 24.51 },
      2: { male: 26.18, female: 26.68 },
      3: { male: 32.13, female: 32.91 },
      4: { male: 40.27, female: 41.54 },
      5: { male: 55.71, female: 58.47 },
    },
    36: {
      0: { male: 17.89, female: 18.08 },
      1: { male: 23.83, female: 24.33 },
      2: { male: 25.95, female: 26.46 },
      3: { male: 31.76, female: 32.55 },
      4: { male: 39.67, female: 40.95 },
      5: { male: 54.36, female: 57.11 },
    },
    37: {
      0: { male: 17.81, female: 18.01 },
      1: { male: 23.61, female: 24.14 },
      2: { male: 25.72, female: 26.23 },
      3: { male: 31.38, female: 32.19 },
      4: { male: 39.07, female: 40.35 },
      5: { male: 53.03, female: 55.76 },
    },
    38: {
      0: { male: 17.72, female: 17.93 },
      1: { male: 23.38, female: 23.94 },
      2: { male: 25.47, female: 26 },
      3: { male: 31, female: 31.82 },
      4: { male: 38.46, female: 39.75 },
      5: { male: 51.72, female: 54.43 },
    },
    39: {
      0: { male: 17.63, female: 17.85 },
      1: { male: 23.15, female: 23.74 },
      2: { male: 25.22, female: 25.76 },
      3: { male: 30.61, female: 31.44 },
      4: { male: 37.85, female: 39.15 },
      5: { male: 50.44, female: 53.12 },
    },
    40: {
      0: { male: 17.54, female: 17.77 },
      1: { male: 22.92, female: 23.53 },
      2: { male: 24.97, female: 25.52 },
      3: { male: 30.21, female: 31.06 },
      4: { male: 37.23, female: 38.54 },
      5: { male: 49.17, female: 51.82 },
    },
    41: {
      0: { male: 17.44, female: 17.68 },
      1: { male: 22.68, female: 23.31 },
      2: { male: 24.71, female: 25.28 },
      3: { male: 29.81, female: 30.67 },
      4: { male: 36.6, female: 37.93 },
      5: { male: 47.92, female: 50.55 },
    },
    42: {
      0: { male: 17.34, female: 17.59 },
      1: { male: 22.43, female: 23.08 },
      2: { male: 24.44, female: 25.02 },
      3: { male: 29.4, female: 30.28 },
      4: { male: 35.97, female: 37.31 },
      5: { male: 46.69, female: 49.29 },
    },
    43: {
      0: { male: 17.24, female: 17.49 },
      1: { male: 22.18, female: 22.84 },
      2: { male: 24.16, female: 24.76 },
      3: { male: 28.98, female: 29.88 },
      4: { male: 35.34, female: 36.69 },
      5: { male: 45.48, female: 48.06 },
    },
    44: {
      0: { male: 17.13, female: 17.39 },
      1: { male: 21.93, female: 22.6 },
      2: { male: 23.88, female: 24.49 },
      3: { male: 28.56, female: 29.47 },
      4: { male: 34.7, female: 36.06 },
      5: { male: 44.29, female: 46.84 },
    },
    45: {
      0: { male: 17.01, female: 17.28 },
      1: { male: 21.67, female: 22.35 },
      2: { male: 23.59, female: 24.22 },
      3: { male: 28.13, female: 29.05 },
      4: { male: 34.06, female: 35.43 },
      5: { male: 43.12, female: 45.64 },
    },
    46: {
      0: { male: 16.89, female: 17.16 },
      1: { male: 21.41, female: 22.1 },
      2: { male: 23.3, female: 23.93 },
      3: { male: 27.7, female: 28.63 },
      4: { male: 33.41, female: 34.79 },
      5: { male: 41.97, female: 44.45 },
    },
    47: {
      0: { male: 16.76, female: 17.04 },
      1: { male: 21.14, female: 21.84 },
      2: { male: 23, female: 23.65 },
      3: { male: 27.26, female: 28.2 },
      4: { male: 32.76, female: 34.15 },
      5: { male: 40.83, female: 43.28 },
    },
    48: {
      0: { male: 16.62, female: 16.91 },
      1: { male: 20.86, female: 21.58 },
      2: { male: 22.69, female: 23.35 },
      3: { male: 26.81, female: 27.77 },
      4: { male: 32.12, female: 33.5 },
      5: { male: 39.71, female: 42.13 },
    },
    49: {
      0: { male: 16.48, female: 16.78 },
      1: { male: 20.58, female: 21.31 },
      2: { male: 22.38, female: 23.05 },
      3: { male: 26.37, female: 27.33 },
      4: { male: 31.47, female: 32.86 },
      5: { male: 38.61, female: 40.99 },
    },
    50: {
      0: { male: 16.33, female: 16.64 },
      1: { male: 20.3, female: 21.03 },
      2: { male: 22.07, female: 22.75 },
      3: { male: 25.92, female: 26.89 },
      4: { male: 30.83, female: 32.21 },
      5: { male: 37.53, female: 39.87 },
    },
    51: {
      0: { male: 16.18, female: 16.5 },
      1: { male: 20.01, female: 20.75 },
      2: { male: 21.75, female: 22.43 },
      3: { male: 25.47, female: 26.44 },
      4: { male: 30.18, female: 31.56 },
      5: { male: 36.46, female: 38.76 },
    },
    52: {
      0: { male: 16.03, female: 16.35 },
      1: { male: 19.72, female: 20.46 },
      2: { male: 21.43, female: 22.12 },
      3: { male: 25.02, female: 25.99 },
      4: { male: 29.53, female: 30.91 },
      5: { male: 35.41, female: 37.67 },
    },
    53: {
      0: { male: 15.86, female: 16.19 },
      1: { male: 19.42, female: 20.16 },
      2: { male: 21.1, female: 21.8 },
      3: { male: 24.56, female: 25.53 },
      4: { male: 28.89, female: 30.26 },
      5: { male: 34.37, female: 36.6 },
    },
    54: {
      0: { male: 15.7, female: 16.03 },
      1: { male: 19.11, female: 19.86 },
      2: { male: 20.77, female: 21.47 },
      3: { male: 24.09, female: 25.07 },
      4: { male: 28.24, female: 29.61 },
      5: { male: 33.35, female: 35.54 },
    },
    55: {
      0: { male: 15.52, female: 15.86 },
      1: { male: 18.8, female: 19.56 },
      2: { male: 20.43, female: 21.14 },
      3: { male: 23.63, female: 24.6 },
      4: { male: 27.59, female: 28.95 },
      5: { male: 32.34, female: 34.49 },
    },
    56: {
      0: { male: 15.37, female: 15.89 },
      1: { male: 18.47, female: 19.21 },
      2: { male: 20.09, female: 20.8 },
      3: { male: 23.15, female: 24.13 },
      4: { male: 26.94, female: 28.29 },
      5: { male: 31.33, female: 33.38 },
    },
    57: {
      0: { male: 15.15, female: 15.68 },
      1: { male: 18.15, female: 18.85 },
      2: { male: 19.73, female: 20.45 },
      3: { male: 22.67, female: 23.65 },
      4: { male: 26.28, female: 27.63 },
      5: { male: 30.33, female: 32.29 },
    },
    58: {
      0: { male: 14.92, female: 15.46 },
      1: { male: 17.8, female: 18.49 },
      2: { male: 19.37, female: 20.1 },
      3: { male: 22.18, female: 23.17 },
      4: { male: 25.6, female: 26.97 },
      5: { male: 29.34, female: 31.21 },
    },
    59: {
      0: { male: 14.69, female: 15.24 },
      1: { male: 17.46, female: 18.12 },
      2: { male: 19, female: 19.73 },
      3: { male: 21.69, female: 22.68 },
      4: { male: 24.86, female: 26.23 },
      5: { male: 28.36, female: 30.15 },
    },
    60: {
      0: { male: 14.45, female: 15.01 },
      1: { male: 16.81, female: 17.39 },
      2: { male: 18.62, female: 19.37 },
      3: { male: 21.11, female: 22.09 },
      4: { male: 23.95, female: 25.43 },
      5: { male: 27.4, female: 29.1 },
    },
    61: {
      0: { male: 14.21, female: 14.78 },
      1: { male: 16.55, female: 17.23 },
      2: { male: 18.24, female: 19 },
      3: { male: 20.67, female: 21.7 },
      4: { male: 23.27, female: 24.72 },
      5: { male: 26.34, female: 28.16 },
    },
    62: {
      0: { male: 13.96, female: 14.55 },
      1: { male: 16.2, female: 16.91 },
      2: { male: 17.84, female: 18.63 },
      3: { male: 20.06, female: 21.21 },
      4: { male: 22.46, female: 24.01 },
      5: { male: 25.31, female: 27.24 },
    },
    63: {
      0: { male: 13.71, female: 14.31 },
      1: { male: 15.86, female: 16.53 },
      2: { male: 17.44, female: 18.26 },
      3: { male: 19.41, female: 20.45 },
      4: { male: 21.65, female: 22.96 },
      5: { male: 24.29, female: 25.93 },
    },
    64: {
      0: { male: 13.46, female: 14.06 },
      1: { male: 15.43, female: 15.96 },
      2: { male: 16.98, female: 17.65 },
      3: { male: 18.77, female: 19.62 },
      4: { male: 20.85, female: 21.94 },
      5: { male: 23.29, female: 24.68 },
    },
    65: {
      0: { male: 13.2, female: 13.81 },
      1: { male: 15.11, female: 15.66 },
      2: { male: 16.62, female: 17.31 },
      3: { male: 18.43, female: 19.24 },
      4: { male: 20.53, female: 21.5 },
      5: { male: 22.97, female: 24.17 },
    },
    66: {
      0: { male: 12.95, female: 13.58 },
      1: { male: 14.73, female: 15.52 },
      2: { male: 16.2, female: 17.1 },
      3: { male: 17.87, female: 18.94 },
      4: { male: 19.79, female: 21.09 },
      5: { male: 22.06, female: 23.61 },
    },
    67: {
      0: { male: 12.69, female: 13.33 },
      1: { male: 14.37, female: 15.3 },
      2: { male: 15.71, female: 16.71 },
      3: { male: 17.28, female: 18.63 },
      4: { male: 19.07, female: 20.66 },
      5: { male: 21.16, female: 23.04 },
    },
    68: {
      0: { male: 12.44, female: 13.08 },
      1: { male: 13.99, female: 14.94 },
      2: { male: 15.25, female: 16.31 },
      3: { male: 16.72, female: 18.01 },
      4: { male: 18.39, female: 19.9 },
      5: { male: 20.33, female: 22.09 },
    },
    69: {
      0: { male: 12.19, female: 12.82 },
      1: { male: 13.62, female: 14.54 },
      2: { male: 14.81, female: 15.87 },
      3: { male: 16.14, female: 17.39 },
      4: { male: 17.68, female: 19.14 },
      5: { male: 19.47, female: 21.17 },
    },
    70: {
      0: { male: 11.94, female: 12.55 },
      1: { male: 13.23, female: 14.12 },
      2: { male: 14.35, female: 15.36 },
      3: { male: 15.59, female: 16.78 },
      4: { male: 17.03, female: 18.4 },
      5: { male: 18.64, female: 20.26 },
    },
    71: {
      0: { male: 11.68, female: 12.28 },
      1: { male: 12.68, female: 13.66 },
      2: { male: 13.69, female: 14.84 },
      3: { male: 14.84, female: 16.15 },
      4: { male: 16.1, female: 17.64 },
      5: { male: 17.57, female: 19.35 },
    },
    72: {
      0: { male: 11.39, female: 12 },
      1: { male: 12.34, female: 13.25 },
      2: { male: 13.27, female: 14.33 },
      3: { male: 14.32, female: 15.54 },
      4: { male: 15.5, female: 16.91 },
      5: { male: 16.82, female: 18.46 },
    },
    73: {
      0: { male: 11.1, female: 11.72 },
      1: { male: 11.99, female: 12.83 },
      2: { male: 12.86, female: 13.82 },
      3: { male: 13.85, female: 14.94 },
      4: { male: 14.92, female: 16.2 },
      5: { male: 16.14, female: 17.62 },
    },
    74: {
      0: { male: 10.83, female: 11.44 },
      1: { male: 11.65, female: 12.41 },
      2: { male: 12.47, female: 13.34 },
      3: { male: 13.38, female: 14.37 },
      4: { male: 14.37, female: 15.52 },
      5: { male: 15.47, female: 16.81 },
    },
    75: {
      0: { male: 10.55, female: 11.16 },
      1: { male: 11.33, female: 12.25 },
      2: { male: 12.09, female: 13.14 },
      3: { male: 12.92, female: 14.18 },
      4: { male: 13.85, female: 15.33 },
      5: { male: 14.86, female: 16.62 },
    },
    76: {
      0: { male: 10.29, female: 10.94 },
      1: { male: 11.01, female: 11.9 },
      2: { male: 11.73, female: 12.72 },
      3: { male: 12.49, female: 13.67 },
      4: { male: 13.36, female: 14.74 },
      5: { male: 14.28, female: 15.95 },
    },
    77: {
      0: { male: 10.04, female: 10.63 },
      1: { male: 10.73, female: 11.58 },
      2: { male: 11.38, female: 12.31 },
      3: { male: 12.11, female: 13.19 },
      4: { male: 12.88, female: 14.17 },
      5: { male: 13.73, female: 15.33 },
    },
    78: {
      0: { male: 9.82, female: 10.33 },
      1: { male: 10.45, female: 11.27 },
      2: { male: 11.06, female: 11.92 },
      3: { male: 11.73, female: 12.74 },
      4: { male: 12.45, female: 13.64 },
      5: { male: 13.25, female: 14.73 },
    },
    79: {
      0: { male: 9.59, female: 10.05 },
      1: { male: 10.19, female: 10.97 },
      2: { male: 10.76, female: 11.56 },
      3: { male: 11.38, female: 12.31 },
      4: { male: 12.06, female: 13.14 },
      5: { male: 12.78, female: 14.2 },
    },
    80: {
      0: { male: 9.38, female: 9.98 },
      1: { male: 9.94, female: 10.7 },
      2: { male: 10.49, female: 11.21 },
      3: { male: 11.07, female: 11.92 },
      4: { male: 11.7, female: 12.68 },
      5: { male: 12.38, female: 13.69 },
    },
  },
  fgsafeincomeadvantage: {
    50: 0.0382,
    51: 0.039,
    52: 0.0399,
    53: 0.0407,
    54: 0.0416,
    55: 0.0425,
    56: 0.0435,
    57: 0.0446,
    58: 0.0455,
    59: 0.0466,
    60: 0.0477,
    61: 0.0488,
    62: 0.0498,
    63: 0.0509,
    64: 0.052,
    65: 0.0532,
    66: 0.0543,
    67: 0.0555,
    68: 0.0566,
    69: 0.0578,
    70: 0.059,
    71: 0.0603,
    72: 0.0616,
    73: 0.062,
    74: 0.0625,
    75: 0.0632,
    76: 0.0637,
    77: 0.0645,
    78: 0.0654,
    79: 0.0661,
    80: 0.067,
    81: 0,
    82: 0,
    83: 0,
    84: 0,
    85: 0,
    86: 0,
    87: 0,
    88: 0,
    89: 0,
    90: 0,
    91: 0,
    92: 0,
    93: 0,
    94: 0,
    95: 0,
    96: 0,
    97: 0,
    98: 0,
    99: 0,
    100: 0,
  },
  fersMRAtable: {
    1964: [56, 0],
    1965: [56, 2],
    1966: [56, 4],
    1967: [56, 6],
    1968: [56, 8],
    1969: [56, 10],
    1970: [57, 0],
  },
}

export default dashboardData
